import React from 'react';
import PropTypes from 'prop-types';

import ResultToolbarDefaultView from './ResultToolbarDefaultView';
import ResultToolbarHeatmapView from './ResultToolbarHeatmapView';

import './ResultToolbar.custom.scss';
import './ResultToolbar.theme.scss';

export default function ResultToolbar(props) {
  const { openHeatmapIndicator } = props;

  if (openHeatmapIndicator) {
    return <ResultToolbarHeatmapView {...props} />;
  }

  return <ResultToolbarDefaultView {...props} />;
}

ResultToolbar.propTypes = {
  openHeatmapIndicator: PropTypes.bool.isRequired,
};
